import { render, staticRenderFns } from "./CatalogDetail.vue?vue&type=template&id=05d73eb4&scoped=true"
import script from "./CatalogDetail.vue?vue&type=script&lang=ts"
export * from "./CatalogDetail.vue?vue&type=script&lang=ts"
import style0 from "./CatalogDetail.vue?vue&type=style&index=0&id=05d73eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d73eb4",
  null
  
)

export default component.exports